import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["active", "published"]

  activeChanged() {
    if (!this.activeTarget.checked) {
      this.publishedTarget.checked = false
    }
  }

  publishedChanged() {
    if (this.publishedTarget.checked) {
      this.activeTarget.checked = true
    }
  }
}
